import { render, staticRenderFns } from "./OnboardingAvatarForm.vue?vue&type=template&id=2b2aceb3&scoped=true"
import script from "./OnboardingAvatarForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./OnboardingAvatarForm.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./OnboardingAvatarForm.vue?vue&type=style&index=0&id=2b2aceb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2aceb3",
  null
  
)

export default component.exports